import React, { Component } from 'react'
import {Grid} from 'semantic-ui-react';
import data from '../../assets/json/about/ourmission.json';
import headerBorder from '../../assets/images/line-orange.png';

export default class OurMission extends Component {
	state = {
		data: data.mission
	};
	
	
  render() {
	  let {data} = this.state;
	var createReactClass = require('create-react-class');
		var ImagePreview = createReactClass({
			getInitialState() {
				return {
				  hover: false
				};
			},
			render: function(){
				return (
					<Grid>
						<Grid.Column width={2}>
							<img src={this.props.src} alt="" className="icn-about-us"/>
						</Grid.Column>
						<Grid.Column width={14} className="our-mission-desc">
							<p className="para-content">{this.props.caption}</p>
						</Grid.Column>
					</Grid>
				);
			}
		});
		
		
		return (
			<>
				<Grid >
					<Grid.Column width={16} className="align-center">
						<h1 className="section-header align-center">Our Mission</h1>
						<img src={headerBorder} className="header-border align-center" alt="" />
					</Grid.Column>	
				</Grid>
				{
					data.map((img,i) => (
						<div className="our-mission-wrapper" key={i}>
							<ImagePreview
								src={img.photo}
								caption={img.caption}
							/>
						</div>
					))
				}
			</>
        );
	}
}
